module.exports = __webpack_public_path__ + "assets/img/2769a5ff6b5b1317000a8b39665b2638.png";